import Sku from '@kissui/components/src/sku'
import { VARIATION_PDP, VARIATION_PLP } from '@kissui/components/src/sku/constants'
import { renderLabelTechnology } from '@kissui/components/src/sku/fragments/labelTechnology'
import { renderLabelRange } from '@kissui/components/src/sku/fragments/labelRange'
import { renderHeadline } from '@kissui/components/src/sku/fragments/headline'
import { renderHeading } from '@kissui/components/src/sku/fragments/heading'
import { renderImage } from '@kissui/components/src/sku/fragments/image'
import { renderColors } from '@kissui/helpers/src/colors.helpers'
import { renderRatings, renderRatingsWithData } from './fragments/ratings'
import { renderEnergyLabel } from '@kissui/helpers/src/energy-label.helpers'
import { renderVoltage } from './fragments/voltage'
import { isRatingEnabled } from '@kissui/helpers/src/rating.service'
import { EVENT_COLOR_CLICKED } from '@kissui/components/src/colors/components/color/constants.mjs'
import { readEvent } from '@kissui/helpers/src/assets/js/eventDispatch'
import { getProduct, getPriceFormatter, getCurrency } from '@kissui/helpers/src/catalog'
import scrollTo from '@kissui/helpers/src/scrollTo'
import { apiOverride } from '@kissui/components/src/sku/services'

class SkuMachine extends Sku {
    constructor() {
        super()
        this.type = 'machine'
        this.reviewLink = null
        this.boundOnColorClick = this.onColorClick.bind(this)
        this.boundOnReviewLinkClick = this.onReviewLinkClick.bind(this)
    }

    renderHeader() {
        return `${this.renderHeaderDefault()}
                ${renderEnergyLabel(this.props)}`
    }

    renderInformation() {
        const { variation } = this.props

        if (variation === VARIATION_PDP) {
            return this.renderInformationPDP()
        }
        if (variation === VARIATION_PLP) {
            return this.renderInformationPLP()
        }

        return this.renderInformationDefault()
    }

    renderInformationDefault() {
        return `${renderColors(this.props)}
                ${renderLabelTechnology(this.props)}
                ${renderLabelRange(this.props)}
                ${renderHeading(this.props)}
                ${
                    this.props.show_ratings && isRatingEnabled(this.props)
                        ? `<div class="cb-ratings-block"><nb-loader></nb-loader></div> ${renderRatings(
                              this.props,
                              this
                          )}`
                        : ''
                }
                ${renderHeadline(this.props)}`
    }

    renderInformationPLP() {
        return `${renderColors(this.props)}
                ${renderLabelTechnology(this.props)}
                ${renderLabelRange(this.props)}
                ${renderHeading(this.props)}
                ${
                    this.props.show_ratings
                        ? `<div class="cb-ratings-block"><nb-loader></nb-loader></div> ${renderRatings(
                              { ...this.props, sku: this.props.sku || this.props.legacyId },
                              this
                          )}`
                        : ''
                }
                ${renderHeadline(this.props)}`
    }

    renderInformationPDP() {
        const { showVoltage = {} } = this.props
        return `${renderLabelTechnology(this.props)}
                ${renderLabelRange(this.props)}
                ${renderHeading(this.props)}
                ${renderHeadline(this.props)}
                ${renderRatingsWithData(this.props)}
                ${renderVoltage(showVoltage)}
                ${renderColors(this.props)}`
    }

    renderVisualDefault() {
        const { variation } = this.props
        if (variation === VARIATION_PDP) {
            return ''
        }

        return renderImage(this.props)
    }

    onReviewLinkClick(e) {
        e.preventDefault()
        if (document.querySelector('nb-rating-reviews')) {
            scrollTo(`nb-rating-reviews`)
        }
    }

    onColorClick(e) {
        const event = readEvent(e)
        if (!event.sku) {
            return
        }

        this.template = '<nb-loader></nb-loader>'
        this.render()

        return Promise.all([getPriceFormatter(), getProduct(event.sku)])
            .then(([formatter, payload]) => {
                if (!payload || !formatter) {
                    return
                }

                const newLabels = this.props.colors?.find(c => c.sku === event.sku)?.labels

                this.props = {
                    ...this.props,
                    ...payload,
                    colors: this.props.colors,
                    sku: payload.legacyId || '',
                    longSku: payload.id || '',
                    image: payload.responsiveImages?.standard || payload.images?.icon || '',
                    image_alt_text: payload.name || '',
                    price: formatter.short(getCurrency(), payload.price),
                    activeSku: payload.legacyId || '',
                    activeLongSku: payload.id || '',
                    url: payload.pdpURLs?.desktop || '',
                    labels: newLabels,
                    ...apiOverride(payload, this.props)
                }
            })
            .catch(() => {
                console.error(`getProduct fail on sku ${event.sku}`)
            })
            .finally(() => {
                this.loadTemplate()
                this.onReady?.()
            })
    }

    bindEvent() {
        this.addEventListener(EVENT_COLOR_CLICKED, this.boundOnColorClick)

        this.reviewLink = this.querySelector('.is-review')
        if (this.reviewLink) {
            this.reviewLink.addEventListener('click', this.boundOnReviewLinkClick)
        }
    }

    unbindEvent() {
        this.removeEventListener(EVENT_COLOR_CLICKED, this.boundOnColorClick)

        if (this.reviewLink) {
            this.reviewLink.removeEventListener('click', this.boundOnReviewLinkClick)
        }
    }

    disconnectedCallback() {
        this.unbindEvent()
    }
}

customElements.get('nb-sku-machine') || customElements.define('nb-sku-machine', SkuMachine)

export default SkuMachine
